const pug = require("!../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv\u003E\u003Cicon name=\"avatar-mute\" width=\"350\" height=\"197\"\u003E \u003C\u002Ficon\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;